import React, { useEffect, useState } from 'react';
import { findDrugNames } from '../../../drugData/lookupDrugs';
import { medsCreateState, createMedsStep } from 'store/storeValtio';
import ConfirmModal from '../../common/ConfirmModal';
import { lookupMedByName } from 'helpers/medicationHelpers';

export default function MedicationName({ nextStep, handleChange}) {
  //console.log('MedicationName');
  const [name,setName] = useState('');
  const [error, setError] = useState(null);
  const [medNames, setMedNames] = useState([]);
  const [popup, setPopup] = useState({
    show: false,
    name: '',
    generic: '',
    type: 'X',
    class: 'X',
    id: 0,
  });

  useEffect(() => {
    if (medsCreateState.name !== '') {
      setName(medsCreateState.name);
      const names = [];
      const nl = {
        name: medsCreateState.name,
        class: 'N',
        type: 'X',
        id: 0,
      }
      names.push(nl);
      //console.log('names',names)
      setMedNames(names);
    }
  },[])

  function nameChange(e) {
    //console.log('nameChange', e.target.value);
    if (error) setError(null);
    const txt = e.target.value;
    const tu = txt.toUpperCase();
    setName(tu);
    const names = findDrugNames(txt);
    //console.log('names', names, tu);
  
    const isIn = names.some(n => n.name === tu);
    if (!isIn) {
      //console.log('not included', names, tu);
      const nl = {
        name: tu,
        class: 'N',
        type: 'X',
        id: 0,
      }
      names.unshift(nl);
    }
    //console.log('names',names)
    setMedNames(names);
  }

  function confirmName(n) {
    //console.log('confirmName', n);
    setPopup({ show: true, name: n.name, type: 'X', id: 0 });
  };

  function selectDrug(n) {
    //console.log('selectDrug', n);
    const name = lookupMedByName(n.name);
    if (name) {
      setError('The medication name is already in use');
      return;
    }
    setName(n.name);
    if (n.type === 'N') {
      confirmName(n)
      return;
      }

    doSelect(n);
  }

  function doSelect(n) {
    //console.log('doSelect', n);
    medsCreateState.orangeId = n.id;
    medsCreateState.type = n.type;
    medsCreateState.class = n.class;
  if (n.type === 'T') {
      medsCreateState.name = n.generic;
      medsCreateState.brand = n.name;
      nextStep(createMedsStep.type);
    } else {
      medsCreateState.name = n.name;
      nextStep(createMedsStep.brand);
    }
  }

  function confirm(tf) {
    //console.log('confirm', tf);
    if (tf) {
      doSelect(popup)
    }
    setPopup({ show: false });
  }

  const li = 'mcard w-[75%] border-2 border-gray-500 px-2 mx-1';
  return (
    <>
      <div className='medBody'>
          What is the <b>name</b> of your medication?
      </div>
      {error && (
        <div
          className='bg-red-100 rounded-lg p-2 mx-10 mb-3 text-base text-red-700'
          role='alert'
        >
          {error}
        </div>
      )}
      <ConfirmModal
          open={popup.show} 
          onConfirm={()=>confirm(true)}
          onCancel={()=>confirm(false)}
          title={'Use this medication name?'}
          content={popup.name}
          confirmButton='Use Name'
          />

      <div className='medName'>
        <input 
          autoFocus 
          value={name} 
          onChange={(e)=>nameChange(e)} 
          className='medInput' 
          id='med_name' 
          name='med_name' 
          type='text' 
          autoComplete='off' 
          required /> 
      </div>
      <div className='medList'>
        {/* <ul className='itemList'> */}
          {medNames.map((n,ix) => {
            return (
              <div
                key={ix} 
                className="medItem" 
                onClick={()=>selectDrug(n)} 
                >
                {n.name}
              </div>
              )
            })
          }
        {/* </ul> */}
      </div>
    </>
  );
}
